var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { loading: _vm.$apollo.loading, hasData: !!_vm.project } },
        [
          _c(
            "div",
            { staticClass: "flex flex-col xl:flex-col mb-2 sm:mb-0 w-full" },
            [
              _c(
                "div",
                {
                  staticClass: "flex flex-col xl:flex-row gap-4 items-stretch",
                },
                [
                  _c("ProjectHeader", {
                    attrs: {
                      project: _vm.project,
                      userRole: _vm.currentUser.role,
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "hidden sm:block bg-white rounded-lg shadow-md document-sec",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "border-b border-gray-200 px-3 pt-4 pb-1",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "-mb-px flex flex-row justify-between",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "whitespace-no-wrap pb-1 border-b-2 border-transparent font-semibold text-lg leading-5 focus:outline-none text-primary-black focus:text-gray-700 focus:border-gray-300 hover:text-gray-700 hover:border-secondary-black",
                                  attrs: { href: "#" },
                                },
                                [_vm._v(" Client documents ")]
                              ),
                              _c(
                                "router-link",
                                {
                                  staticClass: "customTextStyle",
                                  attrs: {
                                    to: `/clients/contractors/${this.project.id}/documents`,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.handleViewAllClick.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" View all ")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c("ProjectDocumentsSideBar", {
                        attrs: {
                          isProject: false,
                          projectCompleted: _vm.project.completed,
                          projectId: _vm.project.id,
                          userRole: _vm.currentUser.role,
                          currentUser: _vm.currentUser,
                          companyId: this.project?.company?.id,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "mt-6 mb-0 gap-4 sm:gap-6 w-full bg-white relative",
            },
            [
              _c("TabsWithRoutes", {
                staticClass: "routeBlock",
                attrs: { routeTabs: _vm.routeTabs, listClass: "pl-5" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: _vm.routes.CONTRACTOR_PROJECT_ACTIVITY,
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "flex items-end" },
                            [
                              _c(
                                "span",
                                { staticClass: "mr-2 text-xs sm:text-lg" },
                                [_vm._v("Visits")]
                              ),
                              _vm.activitiesCount
                                ? _c("TabNotificationBubble", {
                                    attrs: {
                                      notification: _vm.activitiesCount,
                                      info: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.CONTRACTOR_PROJECT_DETAILS,
                      fn: function () {
                        return [
                          _c("span", { staticClass: "flex items-end" }, [
                            _c(
                              "span",
                              { staticClass: "mr-2 text-xs sm:text-lg" },
                              [_vm._v("Details")]
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.CONTRACTOR_PROJECT_CLIENT_PROFILE,
                      fn: function () {
                        return [
                          _c("span", { staticClass: "flex items-end" }, [
                            _c(
                              "span",
                              { staticClass: "mr-2 text-xs sm:text-lg" },
                              [_vm._v("Client Profile")]
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.CONTRACTOR_PROJECT_CARE_PLAN,
                      fn: function () {
                        return [
                          _c("span", { staticClass: "flex items-end" }, [
                            _c(
                              "span",
                              { staticClass: "mr-2 text-xs sm:text-lg" },
                              [_vm._v("Care Plan")]
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.CONTRACTOR_PROJECT_DOCUMENTS,
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "flex items-end" },
                            [
                              _c(
                                "span",
                                { staticClass: "mr-2 text-xs sm:text-lg" },
                                [_vm._v("Documents")]
                              ),
                              _vm.documentsCount
                                ? _c("TabNotificationBubble", {
                                    attrs: {
                                      notification: _vm.documentsCount,
                                      info: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
          _vm.project
            ? _c("router-view", {
                attrs: {
                  currentUser: _vm.currentUser,
                  description: _vm.project.description,
                  userRole: _vm.currentUser.role,
                  currentUserId: _vm.currentUser.id,
                  project: _vm.project,
                  currentUserRole: _vm.currentUser.role,
                  projectSkills: _vm.project.project_skills,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }